/**
 * Month and weekday names, shared by every application. Authored under the
 * `common` namespace in final form (no camelCase→snake_case conversion — that
 * only applies to translation filenames). Apps may override any key in their own
 * `common.json`.
 *
 * Package labels are **not** here: each package owns its own strings and
 * resolves them through @repo/locale-client.
 */
export const sharedResources = {
    pl: {
        common: {
            day_of_week: {
                short: {
                    day_0: 'nd',
                    day_1: 'pon',
                    day_2: 'wt',
                    day_3: 'śr',
                    day_4: 'czw',
                    day_5: 'pt',
                    day_6: 'sob',
                },
                long: {
                    day_0: 'niedziela',
                    day_1: 'poniedziałek',
                    day_2: 'wtorek',
                    day_3: 'środa',
                    day_4: 'czwartek',
                    day_5: 'piątek',
                    day_6: 'sobota',
                },
            },
            months: {
                long: {
                    month_0: 'Styczeń',
                    month_1: 'Luty',
                    month_2: 'Marzec',
                    month_3: 'Kwiecień',
                    month_4: 'Maj',
                    month_5: 'Czerwiec',
                    month_6: 'Lipiec',
                    month_7: 'Sierpień',
                    month_8: 'Wrzesień',
                    month_9: 'Październik',
                    month_10: 'Listopad',
                    month_11: 'Grudzień',
                },
            },
        },
    },
    en: {
        common: {
            day_of_week: {
                short: {
                    day_0: 'Sun',
                    day_1: 'Mon',
                    day_2: 'Tue',
                    day_3: 'Wed',
                    day_4: 'Thu',
                    day_5: 'Fri',
                    day_6: 'Sat',
                },
                long: {
                    day_0: 'Sunday',
                    day_1: 'Monday',
                    day_2: 'Tuesday',
                    day_3: 'Wednesday',
                    day_4: 'Thursday',
                    day_5: 'Friday',
                    day_6: 'Saturday',
                },
            },
            months: {
                long: {
                    month_0: 'January',
                    month_1: 'February',
                    month_2: 'March',
                    month_3: 'April',
                    month_4: 'May',
                    month_5: 'June',
                    month_6: 'July',
                    month_7: 'August',
                    month_8: 'September',
                    month_9: 'October',
                    month_10: 'November',
                    month_11: 'December',
                },
            },
        },
    },
};
